import { FC } from 'react';
import BookCardItem from '../book-card-item/BookCardItem';
import styles from './BookCardsList.module.scss';
import { IBooksPageData } from '@/interfaces/booksPage.interface';
import { IGenreBooksData } from '@/interfaces/genreBooksPage.interface';

interface IBookCardsListProps {
  books: IBooksPageData[] | IGenreBooksData[];
  createdDate?: boolean;
  extraClassName?: string;
  isGenrePage?: boolean;
}

const BookCardsList: FC<IBookCardsListProps> = ({ books, createdDate, extraClassName, isGenrePage }) => {
  const getListClassNames = () => (extraClassName ? `${styles.bookCardsList} ${styles[`${extraClassName}`]}` : `${styles.bookCardsList}`);

  return (
    <div className={getListClassNames()} data-cards="list">
      {books.length ? (
        books.map((book) => {
          const createdAt = !!createdDate ? book.created_at : '';
          const freebooks = (book.book && book.book.allow_full_free > 0) || (book.allow_full_free && book.allow_full_free > 0);

          return <BookCardItem type={book.type} freeVersion={!!freebooks} createdAt={createdAt} id={book.id} rating={book.rating} key={book.id} author={book.author} book={!!isGenrePage ? book : book.book} dataName="hidden" />;
        })
      ) : (
        <div>Книги не найдены</div>
      )}
    </div>
  );
};

export default BookCardsList;
